import React from "react"
import { OKLink } from "commons-components/build/OKLink"
import { getTextLinkDescription } from "utilities/dragNDropUpload"
import { i18n } from "core/i18n"

const TEXT_LINK_DESCRIPTION = getTextLinkDescription(true)
export const UploaderContent = ({ onClick }) => {
    return (
        <div className='uploader-box__container'>
            <span
                className='uploader-box__container__description'>{i18n.formatText("dragNDropUpload-defaultDescriptionMultiple")}</span>
            <OKLink
                modifier='emphasize'
                onClick={onClick}
            >
                {TEXT_LINK_DESCRIPTION}
            </OKLink>
        </div>
    )
}
